export const WEBSOCKET_INIT = 'WEBSOCKET_INIT';
export const WEBSOCKET_CONNECTED = 'WEBSOCKET_CONNECTED';
export const WEBSOCKET_DISCONNECTED = 'WEBSOCKET_DISCONNECTED';
export const WEBSOCKET_MESSAGE = 'WEBSOCKET_MESSAGE';
export const WEBSOCKET_PING = 'WEBSOCKET_PING';
export const WEBSOCKET_PING_TIMEOUT = 'WEBSOCKET_PING_TIMEOUT';
export const WEBSOCKET_PONG = 'WEBSOCKET_PONG';
export const NUDGE_RECEIVED = 'NUDGE_RECEIVED';
